export const sadContent = [
  {
    type: "quote",
    text: "It's okay to pause. Even the moon rests between phases."
  },
  {
    type: "joke",
    text: "You don’t have to win today. Showing up is already brave."
  },
  {
    type: "quote",
    text: "Some days, breathing is enough."
  },
  {
    type: "joke",
    text: "Your productivity does not define your worth."
  }
];
